import React from 'react';
import {
  CondensedHeader,
  Gutter,
  ImageCircle,
  Layout,
  ParagraphHeader,
  Visible,
  Well,
} from '@axiom/ui';

import type { TalentPartnerUser } from './SupportContactsModal';

export const SupportContactsModalOther = ({
  user,
  name,
}: {
  user: TalentPartnerUser;
  name: string;
}) => {
  return (
    <div data-test="SUPPORT_CONTACTS_OTHER">
      <Well>
        <CondensedHeader>Before you reach out</CondensedHeader>
        <Gutter bottom="8px" />
        If your question isn't covered by another section, reach out to your
        team directly.
      </Well>
      <Gutter bottom="16px" />
      <Well>
        <ParagraphHeader>Your Talent Success Partner</ParagraphHeader>
        <Gutter bottom="16px" />
        <Layout position="middle" horizontalGutter="16px">
          <Visible only="largeScreen">
            <ImageCircle
              name="TALENT_PARTNER_IMAGE"
              size="small"
              imageName={name}
            />
          </Visible>
          <div>
            <div data-test="TALENT_PARTNER_NAME">{name}</div>
            <a data-test="TALENT_PARTNER_EMAIL" href={`mailto:${user.email}`}>
              {user.email}
            </a>
          </div>
        </Layout>
      </Well>
    </div>
  );
};
